import { Observable } from 'rxjs';
import { Permission } from './../../../models/permission.model';
import { PermsService } from './../../../services/utils/perms.service';
import { Component, OnInit } from '@angular/core';
import {LoyaltySelfscanconfService} from '../../../services/loyalty/loyalty-selfscanconf.service';
import {KontableComponent} from '../../../modules/UIKit/components/kontable/kontable.component';
import {SelfScanConf} from '../../../models/loyalty-selfScan.model';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'app-loyalty-self-scan-rules',
  templateUrl: './loyalty-self-scan-rules.component.html',
  styleUrls: ['./loyalty-self-scan-rules.component.css']
})
export class LoyaltySelfScanRulesComponent implements OnInit {

  newDataAvailable = false;
  serverPagination = KontableComponent.ServerPagination;
  listStates: Array<{value: string, label: string}>;
  selectFilter = KontableComponent.SelectFilter;
  customFilter = KontableComponent.CustomFilter;

  // Mostra tasti di edit, delete e recover
  selfScanningPermissions: Permission;

  render = {
    datatable: false
  };

  constructor(
    public selfscanService: LoyaltySelfscanconfService,
    private router: Router,
    private translate: TranslateService,
    private srvPermission: PermsService
  ) { }

  ngOnInit() {
    const TRANSLATIONS = this.translate.get([
      'common.status_notDeleted',
      'common.status_onlyDeleted',
      'common.status_onlySuspended'
    ]);

    const PERMISSIONS = this.srvPermission.getPermission({ms_base: 'koncentro-loyalty', operation: 'card_def'});


    Observable.zip(
      TRANSLATIONS,
      PERMISSIONS

    ).subscribe(([t, resPermissions]) => {

      this.selfScanningPermissions = resPermissions;

      this.listStates = [];
      this.listStates.push({ label: '', value: null });
      this.listStates.push({ label: t['common.status_notDeleted'], value: '0' });
      this.listStates.push({ label: t['common.status_onlyDeleted'], value: '1' });

      this.render.datatable = true;

  });

  }
  add() {
    this.router.navigate(['/loyalty/selfscanrules/form']);
  }

  edit(selfscanconf: SelfScanConf) {
    this.router.navigate(['/loyalty/selfscanrules/form/' + selfscanconf.id]);
  }

  remove(selfscanconf: SelfScanConf) {
    this.selfscanService.remove(selfscanconf.id).subscribe((res ) => {
      //this.reloadList();
      this.newDataAvailable = true;
    });
  }
  recover(selfScan){
    this.selfscanService.recover(selfScan).subscribe((res) => {
      this.newDataAvailable = true;
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-self-scan-rules/loyalty-self-scan-rules.component.ts